import { useMemo } from 'react';
import DonutChart from '..';
import { element, useElementProps } from '../../../core/elements';
import { scaleOrdinal } from '../../../primitives/scale';
export const DonutScalesElement = element(_ref => {
  let {
    data,
    colorAccessor,
    valueAccessor,
    sort = 'asc',
    children
  } = _ref;
  const {
    fillStyles,
    enableDefaultPatterns,
    useThemeFillStyles
  } = useElementProps(DonutChart.elements.Theme);
  const value = useMemo(() => {
    const sortedData = data.sort((a, b) => {
      if (valueAccessor(a) > valueAccessor(b)) {
        return sort === 'asc' ? 1 : -1;
      }
      if (valueAccessor(a) < valueAccessor(b)) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
    const {
      domain,
      range
    } = useThemeFillStyles({
      fillStyles,
      enableDefaultPatterns
    });
    const colorScale = scaleOrdinal({
      domain: domain ? domain : data.map(colorAccessor),
      range: range
    });
    return {
      colorScale,
      data: sortedData
    };
  }, [data, colorAccessor, valueAccessor, fillStyles, enableDefaultPatterns]);
  return children(value);
});